import { useModuleContext } from "@cognitranlimited/itis-web";
export var aosSubscriptionModuleId = Symbol('aosSubscriptionModule');
export var useAosSubscriptionContext = function () { return useModuleContext(aosSubscriptionModuleId); };
